import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { MdArticle, MdArticleCondition, MdDetailInspection } from 'models/md/MdArticle';
import { MdBldoCondition, MdBldo } from 'models/md/MdBldo';
import { callApi } from 'utils/ApiUtil';

/**
 * 기준정보 > 투자비 산출항목 관리 > 투자항목 목록 조회
 */
export const findMdArticleList = async (condition: MdArticleCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/article`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdArticle[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdArticle[];
};

/**
 * 기준정보 > 투자비 산출항목 관리 > 투자항목 저장
 */
export const saveMdArticleList = async (masterData: MdArticle[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/article`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 기준정보 > 투자비 산출항목 관리 > 상세 점검사항 목록 조회
 */
export const findMdDetailInspectionList = async (condition: MdArticleCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/detail-inspect`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdDetailInspection[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdDetailInspection[];
};

/**
 * 기준정보 > 투자비 산출항목 관리 > 상세 점검사항 저장
 */
export const saveMdDetailInspectionList = async (masterData: MdDetailInspection[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/detail-inspect`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};
